import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../Utils/axiosInstance";
import { toast } from "react-hot-toast";

const initialStateMaintenance = {
    maintenance: null,
    success: false,
    message: '',
    loading: false,
};

const handleErrors = (error, dispatch, rejectWithValue) => {
    const errorMessage = error.response?.data?.message || 'An error occurred';
    return rejectWithValue(error.response?.data || { message: errorMessage });
};

export const getMaintenanceSettings = createAsyncThunk(
    "maintenance/getMaintenanceSettings",
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(`/maintenance`);
            return response.data.data;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const updateMaintenanceSettings = createAsyncThunk(
    "maintenance/updateMaintenanceSettings",
    async (data, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.put(`/maintenance`, data);
            toast.success(response.data.message || "Maintenance settings updated successfully");
            return response.data.data;
        } catch (error) {
            toast.error(error.response?.data?.message || error.message || "Failed to update maintenance settings");
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

const maintenanceSlice = createSlice({
    name: 'maintenance',
    initialState: initialStateMaintenance,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getMaintenanceSettings.pending, (state) => {
                state.loading = true;
            })
            .addCase(getMaintenanceSettings.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.maintenance = action.payload;
            })
            .addCase(getMaintenanceSettings.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch settings';
            })
            .addCase(updateMaintenanceSettings.pending, (state) => {
                state.loading = true;
            })
            .addCase(updateMaintenanceSettings.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.maintenance = action.payload;
            })
            .addCase(updateMaintenanceSettings.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to update settings';
            });
    },
});

export default maintenanceSlice.reducer;
